// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input-checkbox[data-v-7dd916c4]{margin-top:8px;flex:1}", ""]);
// Exports
module.exports = exports;
